import type { IntlShape } from "react-intl";
import type { Shape as ThreeShape } from "three";
import type { Input } from "../../../types/shape";
import type { ThreeInputLinesType, ThreeSidePathsType } from "../../../types/three";
import type { DimensionKeys, DimensionProperties } from "../../../types/workpiece";
import type InputType from "../Input/InputType";
import Shape from "../Shape";
import type { SideName } from "../Side/SideName";

export default abstract class Beam extends Shape {
	public calculateSideLength(_side: SideName, _input: InputType): number | undefined {
		return undefined;
	}

	public getDimensionsString(_input: InputType, _intl: IntlShape): string | undefined {
		return undefined;
	}

	public getConstraints(
		_input: InputType,
		_current: Input,
		_equalCorners?: boolean,
	): number | undefined {
		return undefined;
	}

	public getThreeShape(_: DimensionProperties[DimensionKeys]): undefined | ThreeShape {
		return undefined;
	}

	public getThreeSidePaths(
		_: DimensionProperties[DimensionKeys],
	): undefined | ThreeSidePathsType[] {
		return undefined;
	}

	public getThreeInputLines(
		_: DimensionProperties[DimensionKeys],
	): undefined | ThreeInputLinesType[] {
		return undefined;
	}

	public getDimensions(
		_: DimensionProperties[DimensionKeys],
	): undefined | DimensionProperties[DimensionKeys] {
		return undefined;
	}
}
